import React from "react";
import Select from "react-select";
import Datepicker from "react-datepicker";
import Constants from "../../../configurations/constants";
class PendingClaimsFilter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      institiution: "",
      expiresFromDate: null,
      expiresToDate: null,
      status: "",
      statusOptions: [
        { value: "CHARGEBACK", label: "CHARGEBACK" },
        { value: "PRE_ARBITRATION", label: "PRE ARBITRATION" },
        { value: "PRE_ARBITRATION_II", label: "PRE ARBITRATION II" },
      ],
    };

    this.onExpiresFromDateChange = this.onExpiresFromDateChange.bind(this);
    this.onExpiresToDateChange = this.onExpiresToDateChange.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
  }
  onExpiresFromDateChange(date) {
    this.setState({ expiresFromDate: date });
  }
  onExpiresToDateChange(date) {
    this.setState({ expiresToDate: date });
  }
  onStatusChange(event) {
    this.setState({
      status: event ? event.value : "",
    });
  }
  onSearchHandler() {
    //TODO: validate control values AND BUILD PARAMS

    //Build Params
    let params = {};
    if (this.state.status) params.status = this.state.status;

    if (this.state.expiresFromDate)
      params.expiryStartDate = this.state.expiresFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    if (this.state.expiresToDate)
      params.expireEndDate = this.state.expiresToDate
        .endOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    
    this.props.onSearchHandler && this.props.onSearchHandler(params, true);
  }
  render() {
    return (
      <form
      onSubmit={e => {
        this.onSearchHandler();
        e.preventDefault();
        return false;
      }}
      >
        <div>
          <div className="row filters">
            <div className="col-md-10">
              <div className="row">
                {/* <div className="col-md-3">
                  <label className="input-control-label">Institution</label>
                  <Select
                    id="institution"
                    value={this.state.institiution}
                    // onChange={this.onTextInputChange}
                    placeholder="Institution"
                  />
                </div> */}

                <div className="col-md-3">
                  <label className="input-control-label">Start Due Date</label>

                  <Datepicker
                    onChange={this.onExpiresFromDateChange}
                    className="form-control float_input"
                    id="expiresFromDate"
                    placeholderText="From"
                    disabledKeyboardNavigation
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    maxDate={
                      this.state.expiresToDate ? this.state.expiresToDate : null
                    }
                    dateFormat={Constants.DATE_FORMAT}
                    selected={this.state.expiresFromDate}
                  />
                </div>
                <div className="col-md-3">
                  <label className="input-control-label">End Due Date</label>

                  <Datepicker
                    onChange={this.onExpiresToDateChange}
                    className="form-control float_input"
                    id="expiresToDate"
                    placeholderText="To"
                    disabledKeyboardNavigation
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={
                        this.state.expiresFromDate
                          ? this.state.expiresFromDate.clone().add(1, "days")
                          : null
                      }
                    dateFormat={Constants.DATE_FORMAT}
                    selected={this.state.expiresToDate}
                  />
                </div>
                <div className=" col-md-3" id="statusColumn">
                  <label className="input-control-label">Status</label>
                  <Select
                    name="status"
                    placeholder="Status"
                    value={this.state.status}
                    options={this.state.statusOptions}
                    onChange={this.onStatusChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <br />
              <button
                id="searchButton"
                className="btn btn-primary btn-block"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default PendingClaimsFilter;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/pendingClaims/pendingClaimsFilter.js